import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { hostActions } from '../hostActions';
import type { FuelSavingApplyPayload } from '@makemydeal/dr-activities-fuel-saving';
import {
    APPLY_FUEL_SAVING_CDL,
    APPLY_AND_PRINT_FUEL_SAVING_CDL
} from '@makemydeal/dr-dash-store/actionTypes/fuelEconomyActionTypes';

export function useFuelSavingHandlers() {
    const dispatch = useDispatch();

    const handleApply = useCallback(
        (payload: FuelSavingApplyPayload) => {
            dispatch({ type: APPLY_FUEL_SAVING_CDL });
            dispatch(hostActions.applyFuelSaving(payload));
        },
        [dispatch]
    );

    const handleApplyAndPrint = useCallback(
        (payload: FuelSavingApplyPayload) => {
            dispatch({ type: APPLY_AND_PRINT_FUEL_SAVING_CDL });
            dispatch(hostActions.applyAndPrintFuelSaving(payload));
        },
        [dispatch]
    );

    const handleCancel = useCallback(() => {
        dispatch(hostActions.cancelFuelSaving());
    }, [dispatch]);

    const handleValuesChange = useCallback(
        (payload: FuelSavingApplyPayload) => {
            dispatch(hostActions.persistFuelSavingValues(payload));
        },
        [dispatch]
    );

    return {
        handleApply,
        handleApplyAndPrint,
        handleCancel,
        handleValuesChange
    };
}
